import { ComponentProps, FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { useUBL } from '@common/log-manager';
import { BarAutoAdBanner } from '@widgets/ad';
import { parseQueryString, usePdpConfig } from '@domains/pdp-common';

import { useBannerAdListQuery } from '../query/useBannerAdListQuery';

interface Props {
  banner_index: number;
  position?: 'top' | 'bottom' | 'inner';
}

export const BarAutoAdBannerContainer: FC<React.PropsWithChildren<Props>> = ({ banner_index, position = 'top' }) => {
  const ubl = useUBL();
  const { isZigzagApp: is_zigzag_app } = usePdpConfig();
  const { bar_auto_type_ad_banner_items, is_loading } = useBannerAdListQuery();
  const ad_banner = bar_auto_type_ad_banner_items[banner_index];
  if (!is_zigzag_app || is_loading || ad_banner?.type !== 'BAR_AUTO') {
    return null;
  }

  const ubl_base = {
    navigation: 'product_detail',
    object_type: 'banner',
    object_section: 'bottom_ad_banner',
    object_id: ad_banner.creative_id,
    object_idx: ad_banner.banner_index,
    data: { server_log: ad_banner.log ? parseQueryString(ad_banner.log) : undefined },
  };

  const ubl_handler: ComponentProps<typeof BarAutoAdBanner>['ubl_handler'] = {
    impression: () => {
      ubl({
        ...ubl_base,
        category: 'impression',
      });
    },
    click: () => {
      ubl({
        ...ubl_base,
        category: 'click',
      });
    },
  };

  return (
    <SC.Root position={position}>
      <BarAutoAdBanner item={ad_banner} ubl_handler={ubl_handler} />
    </SC.Root>
  );
};

const SC = {
  Root: styled.section<{ position: 'top' | 'bottom' | 'inner' }>`
    ${({ position }) => styles[position]}
  `,
};

const styles = {
  top: css`
    margin-bottom: 20px;
    padding-top: 20px;
    border-top: 8px solid ${vars.v3Color.gray100};
  `,
  bottom: css`
    margin-bottom: 28px;
  `,
  inner: css`
    margin: 0 -4px 4px;
  `,
};
